import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { viewImage } from "../CommonUtils/viewImage";
import { useDispatch, useSelector } from "react-redux";
import allowNumbersOnly, { AllowFloats, handlePaste, preventZeroInputAndPaste } from '../CommonUtils/CommonValidations';
import { FaEye } from 'react-icons/fa';
import { ImagePdfBucket } from '../CommonUtils/ImagesBase64';
import { failureAlert } from '../CommonUtils/SweetAlerts';
import Alert from 'react-bootstrap/Alert';
import CommonFormHeading from '../CommonUtils/CommonFormHeading';
import { GetCollegeType } from '../Reducers/AffiliationCommonservice';

export default function AfflInstructionalAreaDetails() {
    const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const hasFetchedData = useRef(false);
    const dispatch = useDispatch();
    const [particulars, setParticulars] = useState([]);
    const [buildingNames, setBuildingNames] = useState([]);
    const [floors, setFloors] = useState({});
    const [instArea, setInstArea] = useState([]);
    const [utilRepo, setUtilRepo] = useState([]);
    const InstAreaformik = useFormik({
        initialValues: {
            instructionalArea: [{
                buildBlockSlno: '',
                particularCode: '',
                otherParticulars: '',
                buildBlockName: '',
                floorNoBuildBlock: '',
                noOfRooms: '',
                length: '',
                breadth: '',
                height: '',
                area: '',
                utilization: '',
                buildingImg: '',
                buildingImghidden: "",
            }]
        },
        enableReinitialize: true,
        onSubmit: (val) => {
            const validateRow = (row, index) => {
                let rowValid = true;
                let errorMessages = [];

                if (!row.particularCode || isNaN(row.particularCode)) {
                    errorMessages.push('please fill a valid Particulars.');
                    rowValid = false;
                }
                if (row.particularCode == 17 && !row.otherParticulars) {
                    errorMessages.push('please fill a valid Other Particulars.');
                    rowValid = false;
                }
                if (!row.buildBlockName) {
                    errorMessages.push('please fill Building / Block Name	.');
                    rowValid = false;
                }

                if (row.floorNoBuildBlock === undefined || row.floorNoBuildBlock === '') {
                    errorMessages.push('please fill Level/Floor No.	.');
                    rowValid = false;
                }

                if (!row.noOfRooms || isNaN(row.noOfRooms)) {
                    errorMessages.push('please fill a valid  Room No.');
                    rowValid = false;
                }

                if (!row.length || isNaN(row.length)) {
                    errorMessages.push('please fill a valid length.');
                    rowValid = false;
                }

                if (!row.breadth || isNaN(row.breadth)) {
                    errorMessages.push('please fill a valid breadth.');
                    rowValid = false;
                }

                if (!row.height || isNaN(row.height)) {
                    errorMessages.push('please fill a valid height.');
                    rowValid = false;
                }

                if (row.utilization === '') {
                    errorMessages.push('please fill a valid utilization.');
                    rowValid = false;
                }

                // Check if buildingImg is present
                if (!row.buildingImg) {
                    errorMessages.push('please upload a Room image.');
                    rowValid = false;
                }
                const currentRow = val.instructionalArea[index];
                const zeroLike = (value) => /^0+$/.test(String(value).trim());
                if (zeroLike(currentRow.length) || zeroLike(currentRow.breadth) || zeroLike(currentRow.height)) {
                    Swal.fire({
                        title: 'Invalid Dimensions',
                        text: `Row ${index + 1}: Length, Breadth, and Height must not be zero .`,
                        icon: 'error',
                        confirmButtonText: 'ok',
                        backdrop: false,
                    });
                    return;
                }

                return { rowValid, errorMessages };
            };

            const validateNextRow = (index) => {
                if (index >= val.instructionalArea.length) {

                    Swal.fire({
                        title: 'Are you sure you want to submit?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Submit',
                        backdrop: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            let url = config.url.API_URL + 'InstructionalAreadetails';
                            CommonAxiosPost(url, val).then((res) => {
                                if (res?.data?.scode === '01') {
                                    Swal.fire(res?.data?.sdesc, '', 'success').then(() => {
                                        window.location.reload();
                                    });
                                } else {
                                    failureAlert("Failed to submit")
                                }
                            });
                        }
                    });
                    return;
                }

                const row = val.instructionalArea[index];
                const { rowValid, errorMessages } = validateRow(row, index);

                if (!rowValid) {
                    // If the row is not valid, show the error messages for this row
                    Swal.fire({
                        title: `At S.No ${index + 1}`,

                        html: errorMessages.join('<br>'),
                        icon: 'error',
                        confirmButtonText: 'OK',
                        backdrop: false
                    }).then(() => {

                    });
                } else {
                    validateNextRow(index + 1);
                }
            };

            validateNextRow(0);
        }




    })
    async function GetParticulars() {
        try {
            const url = `${config.url.API_URL}getparticularslist`;
            const res = await CommonAxiosGet(url, dispatch);
            if (res?.data?.scode === '01') {
                setParticulars(res?.data?.parrticularlist);
            } else {
                setParticulars([]);
            }
        } catch (error) {
            console.error('Error fetching particulars list:', error);
            setParticulars([]);
        }

        try {
            const urll = `${config.url.API_URL}getBuildingNames`;
            const res2 = await CommonAxiosGet(urll, dispatch);
            if (res2?.data?.scode === '01') {
                setBuildingNames(res2?.data?.getBuildings);
            } else {
                setBuildingNames([]);
            }
        } catch (error) {
            console.error('Error fetching building names:', error);
            setBuildingNames([]);
        }

        try {
            const urlll = `${config.url.API_URL}getInstructionalArea`;
            const res3 = await CommonAxiosGet(urlll, dispatch);
            if (res3?.data?.scode === '01') {
                setInstArea(res3?.data?.getdata);
            } else {
                setInstArea([]);
            }
        } catch (error) {
            console.error('Error fetching instructional area:', error);
            setInstArea([]);
        }

        try {
            const urllll = `${config.url.API_URL}getAreaReport`;
            const res4 = await CommonAxiosGet(urllll, dispatch);
            if (res4?.data?.scode === '01') {
                setUtilRepo(res4?.data?.getareaReport);
            } else {
                setUtilRepo([]);
            }
        } catch (error) {
            console.error('Error fetching area report:', error);
            setUtilRepo([]);
        }


    }
    async function GetFloors(floor_no, index) {
        const floor = floor_no.split('-')[1];
        const FlorSlno = floor_no.split('-')[0];
        InstAreaformik.setFieldValue(`instructionalArea[${index}].buildBlockSlno`, FlorSlno);
        let url = `${config.url.API_URL}getFloor/${floor}`;
        try {
            const res = await CommonAxiosGet(url, dispatch);
            if (res?.data?.scode === '01') {
                setFloors((prevFloors) => ({
                    ...prevFloors,
                    [index]: res?.data?.getfloors,
                }));
            } else {
                setFloors([]);
            }
        } catch (error) {
            console.error('Error fetching floor data:', error);
        }
    }
    const handleDimensionChange = (e, dimension, index) => {
        const { value } = e.target;
        InstAreaformik.setFieldValue(`instructionalArea[${index}].${dimension}`, value);
        const length = dimension === 'length' ? parseInt(value) : InstAreaformik.values.instructionalArea[index]?.length || 0;
        const breadth = dimension === 'breadth' ? parseInt(value) : InstAreaformik.values.instructionalArea[index]?.breadth || 0;
        const totalArea = length * breadth;
        InstAreaformik.setFieldValue(`instructionalArea[${index}].area`, totalArea || '');
    };
    function DeleteRow(particularCode) {
        Swal.fire({
            title: 'Are you sure want to Delete ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                let url = `${config.url.API_URL}getdelete/${particularCode}`;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        Swal.fire(res?.data?.sdesc, '', 'success').then(() => {
                            window.location.reload();
                        });
                    } else {
                        failureAlert('Failed to Delete');
                    }
                });
            }
        });
    }



    const [InstgetData, setInstgetData] = useState([]);
    function GetInstructionalSetData() {
        let url = config.url.API_URL + `getInstructionaldata`
        CommonAxiosGet(url, dispatch).then(res => {
            if (res?.data?.scode == "01") {
                setInstgetData(res?.data?.getdata);
                res?.data?.getdata?.forEach((data, i) => {
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].particularCode`, data?.particular_code ?? "",);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].otherParticulars`, data?.other_particulars);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].buildBlockName`, data?.build_block_name);
                    GetFloors(data?.build_block_name, i);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].floorNoBuildBlock`, parseInt(data?.floor_no_build_block));
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].noOfRooms`, data?.no_of_rooms);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].length`, data?.length);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].breadth`, data?.breadth);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].height`, data?.height);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].area`, data?.area);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].utilization`, data?.utilization);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].buildingImg`, data?.building_img);
                    InstAreaformik?.setFieldValue(`instructionalArea[${i}].buildBlockSlno`, data?.build_block_name?.split('-')[0]);
                })
            }
            else {
                setInstgetData([]);
            }
        })
    }
    const checkDuplicate = (values, currentIndex) => {
        const current = values[currentIndex];
        const currentCombo = `${current.buildBlockName}_${current.floorNoBuildBlock}_${current.noOfRooms}`;
        return values.some((entry, idx) => {
            const combo = `${entry.buildBlockName}_${entry.floorNoBuildBlock}_${entry.noOfRooms}`;
            return idx !== currentIndex && combo === currentCombo;
        });
    };
    const handleChange = (e, index, fieldName) => {
        const updatedValues = [...InstAreaformik.values.instructionalArea];
        const currentValue = e.target.value;

        updatedValues[index][fieldName] = currentValue;

        InstAreaformik.setFieldValue("instructionalArea", updatedValues);

        const { buildBlockName, floorNoBuildBlock, noOfRooms } = updatedValues[index];

        if (buildBlockName && floorNoBuildBlock && noOfRooms) {
            const isDuplicate = checkDuplicate(updatedValues, index);
            if (isDuplicate) {
                Swal.fire({
                    icon: "warning",
                    title: `Duplicate entry`,
                    text: `Duplicate entry found for ${fieldName} at row ${index + 1}`,
                    confirmButtonText: "OK",
                }).then((d) => {
                    if (d.isConfirmed) {
                        updatedValues[index][fieldName] = "";
                        InstAreaformik.setFieldValue("instructionalArea", updatedValues);
                    }
                });
            }
        }
    };
    useEffect(() => {
        if (!hasFetchedData?.current) {
            GetParticulars();
            GetInstructionalSetData();
            GetCollegeType();
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>
            <bie.Container fluid className="px-1 affl-newdiv" >
                <FormikProvider value={InstAreaformik}>
                    <Form onChange={InstAreaformik?.handleChange} onSubmit={InstAreaformik?.handleSubmit} className="form_adjust" >
                        <CommonFormHeading heading="Instructional Area" />
                        <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100">
                            <div className="inner-herbpage-service-title-sub pt-0"  >
                                <h1 className="">Instructional Area Details</h1>
                            </div>
                            <Alert variant="danger" className='affl-alert' >
                                <p className='mb-0'> Note: Please do not repeat the same Room No. for the same Building Block & Level/Floor<br />
                                </p>
                            </Alert>
                            <bie.Row className="px-2 pt-3 m-0 ">
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th rowSpan={2} style={{ width: '4%' }}>S.No <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Particulars <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Other Particulars  <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '5%' }}>Building / Block Name <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Level/Floor No. <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Room No. <span className="red-number">*</span></th>
                                                <th colSpan={4} style={{ width: '20%' }}>Measurements of Room ({Collegetype}) <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Status of Utilization <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '20%' }}>Upload Room Image <span className="red-number">*</span></th>
                                                <th rowSpan={2} style={{ width: '4%' }}>Action<span className="red-number">*</span></th>
                                            </tr>
                                            <tr>
                                                <th>Length <span className="red-number">*</span></th>
                                                <th>Breadth <span className="red-number">*</span></th>
                                                <th>Height <span className="red-number">*</span></th>
                                                <th>Area in ({Collegetype}) <span className="red-number">*</span></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "center" }}>
                                            <FieldArray name="instructionalArea">
                                                {({ push, remove }) => {
                                                    return (
                                                        <>
                                                            {InstAreaformik?.values?.instructionalArea?.map((detail, index) => (
                                                                <tr key={index}>
                                                                    <td style={{ width: '4%' }}>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            as="select" className="form-control" name={`instructionalArea[${index}].particularCode`}

                                                                            onChange={e => {
                                                                                InstAreaformik.setFieldValue(`instructionalArea[${index}].particularCode`, e.target.value);
                                                                                if (e.target.value !== '17') {
                                                                                    InstAreaformik.setFieldValue(`instructionalArea[${index}].otherParticulars`, '');
                                                                                }
                                                                            }}>
                                                                            <option value=''>--Select--</option>
                                                                            {particulars?.length > 0 && particulars.map((particular, i) => (
                                                                                <option value={particular?.particular_code} key={i}>{particular?.particular_name}</option>
                                                                            ))}
                                                                        </Field>
                                                                        <ErrorMessage name={`instructionalArea[${index}].particularCode`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>

                                                                        <td>
                                                                            {detail?.particularCode == 17 && (
                                                                                <Field type="text" className="form-control" maxLength="20"
                                                                                    name={`instructionalArea[${index}].otherParticulars`}
                                                                                    placeholder="Other Particulars"
                                                                                    style={{ width: "4rem" }}
                                                                                />
                                                                            )}
                                                                            <ErrorMessage name={`instructionalArea[${index}].otherParticulars`} component="div" className="text-error" />
                                                                        </td>


                                                                    </td>
                                                                    <td>
                                                                        <Field type="hidden" name={`instructionalArea[${index}].buildBlockSlno`} />
                                                                        <Field
                                                                            as="select"
                                                                            className="form-control"
                                                                            name={`instructionalArea[${index}].buildBlockName`}
                                                                            onChange={(e) => {
                                                                                handleChange(e, index, "buildBlockName");
                                                                                GetFloors(e.target.value, index);
                                                                            }
                                                                            }
                                                                        >
                                                                            <option value=''>--Select--</option>
                                                                            {buildingNames?.length > 0 &&
                                                                                buildingNames.map((building, i) => (
                                                                                    <option value={building?.floor} key={i}>
                                                                                        {building?.build_block_name}
                                                                                    </option>
                                                                                ))}
                                                                        </Field>

                                                                        <ErrorMessage name={`instructionalArea[${index}].buildBlockName`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control" name={`instructionalArea[${index}].floorNoBuildBlock`}
                                                                            placeholder="Level No"

                                                                            onChange={(e) => handleChange(e, index, "floorNoBuildBlock")}

                                                                        >
                                                                            <option value=''>--Select--</option>
                                                                            {floors[index]?.length > 0 && floors[index].map((level, i) => (
                                                                                <option value={level?.floor} key={i}>{level?.show}</option>
                                                                            ))}
                                                                        </Field>
                                                                        <ErrorMessage name={`instructionalArea[${index}].floorNoBuildBlock`} component="div" className="text-error" />
                                                                    </td>

                                                                    <td>
                                                                        {/* <Field type="text" className="form-control" name={`instructionalArea[${index}].noOfRooms`}
                                                                         onKeyPress={(e) => { allowNumbersOnly(e); preventZeroInputAndPaste(e) }} maxLength="4" onPaste={(e) => handlePaste(e)} style={{ width: "5rem" }} /> */}


                                                                        <Field
                                                                            type="text"
                                                                            className="form-control"
                                                                            name={`instructionalArea[${index}].noOfRooms`}
                                                                            onChange={(e) => handleChange(e, index, "noOfRooms")}
                                                                            onKeyPress={(e) => { allowNumbersOnly(e); preventZeroInputAndPaste(e) }}
                                                                            maxLength="7"
                                                                            onPaste={(e) => handlePaste(e)}
                                                                            style={{ width: "5rem" }}
                                                                        />

                                                                        <ErrorMessage name={`instructionalArea[${index}].noOfRooms`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control" name={`instructionalArea[${index}].length`} onPaste={(e) => handlePaste(e)}
                                                                            onKeyPress={(e) => { AllowFloats(e) }} onChange={(e) => handleDimensionChange(e, 'length', index)}
                                                                            style={{ width: "5rem" }} />
                                                                        <ErrorMessage name={`instructionalArea[${index}].length`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field type="text" className="form-control"
                                                                            name={`instructionalArea[${index}].breadth`} onKeyPress={(e) => { AllowFloats(e) }} onPaste={(e) => handlePaste(e)}
                                                                            onChange={(e) => handleDimensionChange(e, 'breadth', index)} style={{ width: "5rem" }}
                                                                        />
                                                                        <ErrorMessage name={`instructionalArea[${index}].breadth`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="text" className="form-control" name={`instructionalArea[${index}].height`}
                                                                            onKeyPress={(e) => { AllowFloats(e) }} onPaste={(e) => handlePaste(e)} style={{ width: "5rem" }}
                                                                        />
                                                                        <ErrorMessage name={`instructionalArea[${index}].height`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            type="text"
                                                                            className="form-control"
                                                                            name={`instructionalArea[${index}].area`}

                                                                            disabled
                                                                            style={{ width: "7rem" }}
                                                                        />
                                                                        <ErrorMessage name={`instructionalArea[${index}].area`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field component="select" className="form-control" name={`instructionalArea[${index}].utilization`} style={{ width: "8rem" }}>
                                                                            <option value="">--select--</option>
                                                                            <option value="true">Utilized</option>
                                                                            <option value="false">Non-Utilized</option>
                                                                        </Field>
                                                                        <ErrorMessage name={`instructionalArea[${index}].utilization`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td style={{ width: '20%' }}>
                                                                        <bie.Row className='align-items-center'>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>

                                                                                <Field type="hidden" name={`instructionalArea[${index}].buildingImg`} />
                                                                                <Field type="file" className="form-control mt-0" name={`instructionalArea[${index}].buildingImghidden`} accept="image/*"
                                                                                    onChange={(e) => {
                                                                                        let filename = `instructionalArea_buildingImg`
                                                                                        let path = "/Uploads/BuildingImg/2024/"
                                                                                        ImagePdfBucket(e, InstAreaformik, path, `instructionalArea[${index}].buildingImg`, filename, "image")
                                                                                    }}

                                                                                />
                                                                                <ErrorMessage name={`instructionalArea[${index}].buildingImghidden`} component="div" className="text-error" />

                                                                            </bie.Col>
                                                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>

                                                                                {InstAreaformik?.values?.instructionalArea[index].buildingImg && <button type='button' className='btn btn-primary'
                                                                                    onClick={() => { viewImage(InstAreaformik?.values?.instructionalArea[index].buildingImg) }}> <FaEye size={20} />  </button>}
                                                                            </bie.Col>
                                                                        </bie.Row>
                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 && (
                                                                            <button
                                                                                type="button"
                                                                                className="button-title btn btn-sm btn-success "
                                                                                onClick={() => {
                                                                                    push({
                                                                                        particular_code: '',
                                                                                        otherParticulars: '',
                                                                                        build_block_name: '',
                                                                                        floor_no_build_block: '',
                                                                                        no_of_rooms: '',
                                                                                        length: '',
                                                                                        breadth: '',
                                                                                        height: '',
                                                                                        area: '',
                                                                                        utilization: '',
                                                                                        building_img: ''
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <VscDiffAdded />
                                                                            </button>
                                                                        )}
                                                                        {/* {index === InstAreaformik?.values?.instructionalArea?.length - 1 && index >= 1 && ( */}
                                                                        {index >= 1 && (

                                                                            <button type="button" className="button-title btn btn-sm btn-danger"
                                                                                onClick={() => {
                                                                                    remove(index);
                                                                                }}
                                                                            >
                                                                                <BiTrash />
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr >
                                                            ))}
                                                        </>
                                                    );
                                                }}
                                            </FieldArray>

                                        </tbody >
                                    </table>
                                </div>
                                <div className="d-grid gap-2 button-end mb-2">
                                    <button type='submit' className='btn btn-success btn-sm float-end affl-btn'>Update Details</button>
                                </div>
                            </bie.Row>
                            {instArea && instArea?.length > 0 && (
                                <>
                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className="">Instructional Area Details Report</h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Particulars</th>
                                                    <th>Building/Block Name</th>
                                                    <th>Level/Floor No.</th>
                                                    <th>Room no.</th>
                                                    <th>Total Carpet Area Provided({Collegetype})</th>
                                                    <th>Status of Utilization</th>
                                                    <th>Image</th>
                                                    <th>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {instArea?.length > 0 && instArea.map((areadet, i) => (
                                                    <tr>
                                                        <td className='text-left'>{areadet?.particular_name}</td>
                                                        <td className='text-left'> {areadet?.build_block_name}</td>
                                                        <td>{areadet?.floor_no_build_block}</td>
                                                        <td>{areadet?.no_of_rooms}</td>
                                                        <td className='text-left'>{areadet?.total_area}</td>
                                                        <td className='text-left'>{areadet?.utilization}</td>
                                                        <td className='text-center'><button type="button" onClick={() => viewImage(areadet?.building_img)} className='btn btn-primary'><FaEye size={20} /></button></td>
                                                        <td style={{ textAlign: 'center' }}><button type='button' className='btn btn-danger btn-sm' onClick={() => DeleteRow(areadet?.slno)}><BiTrash /></button></td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                            {utilRepo && utilRepo.length > 0 && (
                                <>
                                    <div className="inner-herbpage-service-title-sub"  >
                                        <h1 className="">ClassRoom Utilization Report</h1>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th>Total number Of ClassRooms</th>
                                                    <th>Utilized Class Rooms</th>
                                                    <th>Non-Utilized ClassRooms</th>
                                                    <th>Utilized area</th>
                                                    <th>Non Utilized Area</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ textAlign: "center", fontSize: "12px" }}>
                                                {utilRepo?.length > 0 && utilRepo.map((util, i) => (
                                                    <tr>
                                                        <td>{util?.no_cls_rms}</td>
                                                        <td>{util?.utilization}</td>
                                                        <td>{util?.non_utilization}</td>
                                                        <td>{util?.utilization_area}</td>
                                                        <td>{util?.non_utilization_area}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </bie.Container>
                    </Form>
                </FormikProvider>

            </bie.Container >
        </>
    )
}


